export const PARAGRAPH_OPEN_TAG = '<p>';
export const PARAGRAPH_CLOSE_TAG = '</p>';
export const EMPTY_STATE_OF_RICH_TEXT = `${PARAGRAPH_OPEN_TAG}${PARAGRAPH_CLOSE_TAG}`;
